import { Schema } from "@comparaonline/products-schema";
import MUILink from "@material-ui/core/Link";
import Link from "next/link";
import React from "react";

import { useAppContext } from "../../../../../lib/appContext";
import { useModalDispatcher } from "../../../../common/components/DetailModalProvider";
import { getDetailUrl } from "../../../../..//models/product";

const useModal = () => {
  const openDetailModal = useModalDispatcher();
  return (product: Schema.ProductListProduct) => (evt: React.MouseEvent) => {
    evt.preventDefault();
    openDetailModal(product);
  };
};

export const useDetailLink = () => {
  const { businessUnitSlug, countryCode } = useAppContext();
  const openDetailModal = useModal();
  return (product: Schema.ProductListProduct): React.FC => {
    const url = getDetailUrl(countryCode, businessUnitSlug, product);
    return ({ children, ...props }) => (
      <Link href={url} passHref={true}>
        <MUILink {...props} onClick={openDetailModal(product)}>
          {children}
        </MUILink>
      </Link>
    );
  };
};
